import { render, staticRenderFns } from "./AdminCollections.vue?vue&type=template&id=56f44930&scoped=true&"
import script from "./AdminCollections.vue?vue&type=script&lang=js&"
export * from "./AdminCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f44930",
  null
  
)

export default component.exports